import { useCallback, useEffect, useState } from "react";
import api from "../../lib/api";
import EpisodeForm from "./EpisodeForm";
import EpisodeList from "./EpisodeList";

// Only rendered for the show's linked podcaster.
export default function OwnerPanel({ slug }) {
  const [mine, setMine] = useState([]);
  const load = useCallback(() => {
    api.get(`/podcasts/${slug}/my-episodes`).then(({ data }) => setMine(data.episodes || [])).catch(() => {});
  }, [slug]);
  useEffect(() => { load(); }, [load]);
  return (
    <section className="mt-12" data-testid="podcast-owner-panel">
      <h2 className="font-head text-2xl text-[var(--text-primary)]">Add an episode</h2>
      <p className="mt-1 text-sm text-[var(--text-secondary)]">You're this show's podcaster. Link an episode and tag the films or shows it covers — once approved, it appears on those title pages.</p>
      <EpisodeForm slug={slug} onAdded={load} />
      {mine.length > 0 && (
        <div className="mt-6">
          <h3 className="text-xs font-bold uppercase tracking-widest text-[var(--text-secondary)]">Your episodes</h3>
          <EpisodeList episodes={mine} showStatus testid="podcast-my-episodes" prefix="my-episode" />
        </div>
      )}
    </section>
  );
}
